export default class ContractRangeParameter {
  quantidade: any;

  valor: string;

  constructor(obj: any = {}, precision: number = 2) {
    this.quantidade = obj.quantidade;
    this.valor = parseFloat(obj.valor.toString()).toFixed(precision) || '';
  }
}
